export default __webpack_public_path__ + "2ca8d0daf46e041a3e2bacb216b85fab.svg";